import React, { Component } from "react";
import PropTypes from "prop-types";
import TypographyKit from "../../../components/kit/Typography/TypographyKit";
import { ContentBody, ContentHead } from "../styled";
import FormField from "../../../components/kit/Fields/FormField/FormField";
import IconSearch from "../../../components/kit/Icon/IconSearch";
import Empty from "../../../components/presentation/Empty/Empty";
import Email from "../../../components/smart/Email/Email";
import Loader from "../../../components/presentation/Loader/Loader";
import { compose } from "redux";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import {
  fetchDraftsEmails,
  setDraftsEmails
} from "../../../store/communication/actions";
import withWidth from "../../../hoc/withWidth";
import { api } from "../../../index";

class CommunicationDrafts extends Component {
  constructor(props) {
    super(props);

    this.state = {
      searchValue: ""
    };
  }

  componentDidMount() {
    this.props.fetchDraftsEmails();
  }

  async searchEmails() {
    try {
      const resp = await api.searchEmails("drafts", this.state.searchValue);
      const emails = resp.data.docs;
      this.props.setDraftsEmails(emails);
    } catch (err) {
      console.log(err);
    }
  }

  handleChange(value) {
    this.setState(
      {
        searchValue: value
      },
      this.searchEmails
    );
  }

  handleRedirect = id =>
    this.props.history.push(`${this.props.location.pathname}/${id}`);

  render() {
    const { searchValue } = this.state;
    const { emails, loading, width } = this.props;
    const emailsNotEmpty = emails && emails.length > 0;
    const emailsIsSearching = emailsNotEmpty || searchValue !== "";

    return loading ? (
      <Loader isBlock />
    ) : (
      <>
        <ContentHead>
          <TypographyKit variant={"caption1"}>Drafts</TypographyKit>
          {emailsIsSearching && (
            <FormField
              label={
                width > 520
                  ? null
                  : "Search tournaments, organizations or by email address…"
              }
              fullWidth
              iconAlign={"left"}
              icon={<IconSearch />}
              value={searchValue}
              placeholder={
                width > 520
                  ? "Search tournaments, organizations or by email address…"
                  : null
              }
              onChange={this.handleChange.bind(this)}
            />
          )}
        </ContentHead>
        <ContentBody>
          {emailsNotEmpty > 0 ? (
            emails.map((item, index) => (
              <Email
                handleClick={() => this.handleRedirect(item.id)}
                key={index}
                {...item}
              />
            ))
          ) : (
            <Empty
              message={
                emailsIsSearching ? "DRAFTS NOT FOND" : "YOU HAVE NO DRAFTS"
              }
            />
          )}
        </ContentBody>
      </>
    );
  }
}

CommunicationDrafts.propTypes = {
  loading: PropTypes.bool,
  emails: PropTypes.arrayOf(PropTypes.object),
  fetchDraftsEmails: PropTypes.func.isRequired,
  setDraftsEmails: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  emails: state.communication.drafts,
  loading: state.communication.loading
});

const mapDispatchToProps = {
  fetchDraftsEmails,
  setDraftsEmails
};

export default compose(
  withWidth,
  withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(CommunicationDrafts);
